import { CreateAxiosDefaults } from 'axios';

const { REACT_APP_API_URL, REACT_APP_TIMEOUT } = process.env;

/**
 * Axios 인스턴스 기본 설정
 */
export const DEFAULT_AXIOS_CONFIG: CreateAxiosDefaults = {
  baseURL: REACT_APP_API_URL,
  withCredentials: true,
  timeout: REACT_APP_TIMEOUT ? parseInt(REACT_APP_TIMEOUT) : 3000,
};
